import {Component} from 'react';


class MoneyMgmtQuestionCard extends Component {
  constructor(props) {
    super(props);
    this.state={
      cardNbr: 0
    }   
}
 
render() {
       this.pctCorrect = ((+this.props.questionInfo.nbrCorrect / 
          +this.props.questionInfo.nbrTests)* 100).toFixed(0);  
     this.topicClass = "text-left";
    
  //    questionObj = {questionNbr: questionNbr, questionText: questionAnswerArr[i].text, 
  //          topic: topic, nbrTests: 0, partialCorrect: 0, nbrCorrect: 0, nbrWrong: 0,
       
return <>
      <tr>
            <td className="text-left">
                 {this.props.questionInfo.questionNbr}
            </td>
            <td className="text-left" >
                 {this.props.questionInfo.questionText}
                 <br/><b>Topic:</b> {this.props.questionInfo.topic}
            </td>
            <td className="text-center" >
                 {this.props.questionInfo.nbrCorrect}
            </td>     
            <td className="text-center" >
                 {this.pctCorrect}%
            </td>  
            <td className="text-center" >
                 {this.props.questionInfo.nbrWrong}
            </td>  
            <td className="text-center" >
                 {this.props.questionInfo.partialCorrect}
            </td>     
            <td className="text-center" >
                 {this.props.questionInfo.nbrTests}
            </td>      
      </tr>         
           
   </>
  }
}

export default MoneyMgmtQuestionCard;